import React from "react";
import Button from "react-bootstrap/esm/Button";

function PreStart(props) {
  return (
    <div>
      <h3>Welcome to Pick New!</h3>
      <br />
      To play select "Start Game" below. The object of the game is to select
      what is new. Select the new item 15 times to win!
      <br />
      <div style={{ textAlign: "center", marginTop: "15px" }}>
        <Button onClick={() => props.setStart(true)}>Start Game</Button>
      </div>
    </div>
  );
}

export default PreStart;
